export var CUSTOM_CONTROLS = ['RulerControl', 'ZoomControl'];